module.exports = __webpack_public_path__ + "static/img/pin-larvicide-inactive.d4e92c9.svg";